export const createArrayBufferWithDataView = (length) => {
    const arrayBuffer = new ArrayBuffer(length);
    const dataView = new DataView(arrayBuffer);
    return { arrayBuffer, dataView };
};
//# sourceMappingURL=/build/es2019/functions/create-array-buffer-with-data-view.js.map